// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_dm.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { GenericPayloadResponse, MultiGenericPayloadResponse } from "./stcs_commons.entity";
import { StcsCompAccMapping } from "./stcs_comp_acc_mapping.entity";
import { StcsOrgFsdFlat } from "./stcs_org_fsd_flat.entity";

export const protobufPackage = "stcs_cmw";

export interface DmCompAccDataUploadRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  file_list: DmCompAccDataUploadRequest_FileItem[];
}

export interface DmCompAccDataUploadRequest_FileItem {
  file_content: Uint8Array;
  file_name: string;
}

export interface DmCompAccDataUploadConfirmRequest {
  ref_id_comp: string;
  ref_id_org: string;
  ref_id_user: string;
}

export interface DmCompAcmConfirmRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
}

export interface DmCompAcmGetRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
}

export interface DmCompAcmGetDraftRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
}

export interface DmCompAcmPreviewRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
}

export interface DmCompAcmRestoreRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
}

export interface DmCompAcmSaveDraftRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  comp_acc_mapping: StcsCompAccMapping | undefined;
}

export interface DmOrgFsdFlatGetRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface DmOrgFsdFlatGetDraftRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface DmOrgFsdFlatRestoreRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface DmOrgFsdFlatPreviewRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface DmOrgFsdFlatSaveDraftRequest {
  ref_id_user: string;
  ref_id_org: string;
  obj_org_fsd_flat: StcsOrgFsdFlat | undefined;
}

export interface DmOrgFsdFlatConfirmRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface DmOrgFsdTemplateListRequest {
  ref_id_user: string;
}

export interface DmOrgFsdTemplateApplyRequest {
  ref_id_user: string;
  ref_id_org: string;
  fpna_industry: number;
}

export interface DmCompDataOverViewRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface DmCompDeleteActualsRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  months_to_delete: number;
  delete_actuals_data: boolean;
}

export interface CreateCompAccMappingRequest {
  ref_id_comp_plan_cfg_template?: string | undefined;
  ref_id_comp: string;
  ref_id_org: string;
  ref_id_user: string;
  display_name: string;
  fpna_begin_date_string: string;
  fpna_end_date_string: string;
}

export interface DeleteCompAccMappingRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface GetCompAccMappingListRequest {
  ref_id_comp: string;
  ref_id_org: string;
  ref_id_user: string;
}

function createBaseDmCompAccDataUploadRequest(): DmCompAccDataUploadRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", file_list: [] };
}

export const DmCompAccDataUploadRequest: MessageFns<DmCompAccDataUploadRequest> = {
  encode(message: DmCompAccDataUploadRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    for (const v of message.file_list) {
      DmCompAccDataUploadRequest_FileItem.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompAccDataUploadRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompAccDataUploadRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.file_list.push(DmCompAccDataUploadRequest_FileItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompAccDataUploadRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      file_list: globalThis.Array.isArray(object?.file_list)
        ? object.file_list.map((e: any) => DmCompAccDataUploadRequest_FileItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DmCompAccDataUploadRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.file_list?.length) {
      obj.file_list = message.file_list.map((e) => DmCompAccDataUploadRequest_FileItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompAccDataUploadRequest>, I>>(base?: I): DmCompAccDataUploadRequest {
    return DmCompAccDataUploadRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompAccDataUploadRequest>, I>>(object: I): DmCompAccDataUploadRequest {
    const message = createBaseDmCompAccDataUploadRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.file_list = object.file_list?.map((e) => DmCompAccDataUploadRequest_FileItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDmCompAccDataUploadRequest_FileItem(): DmCompAccDataUploadRequest_FileItem {
  return { file_content: new Uint8Array(0), file_name: "" };
}

export const DmCompAccDataUploadRequest_FileItem: MessageFns<DmCompAccDataUploadRequest_FileItem> = {
  encode(message: DmCompAccDataUploadRequest_FileItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.file_content.length !== 0) {
      writer.uint32(10).bytes(message.file_content);
    }
    if (message.file_name !== "") {
      writer.uint32(18).string(message.file_name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompAccDataUploadRequest_FileItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompAccDataUploadRequest_FileItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.file_content = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.file_name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompAccDataUploadRequest_FileItem {
    return {
      file_content: isSet(object.file_content) ? bytesFromBase64(object.file_content) : new Uint8Array(0),
      file_name: isSet(object.file_name) ? globalThis.String(object.file_name) : "",
    };
  },

  toJSON(message: DmCompAccDataUploadRequest_FileItem): unknown {
    const obj: any = {};
    if (message.file_content.length !== 0) {
      obj.file_content = base64FromBytes(message.file_content);
    }
    if (message.file_name !== "") {
      obj.file_name = message.file_name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompAccDataUploadRequest_FileItem>, I>>(
    base?: I,
  ): DmCompAccDataUploadRequest_FileItem {
    return DmCompAccDataUploadRequest_FileItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompAccDataUploadRequest_FileItem>, I>>(
    object: I,
  ): DmCompAccDataUploadRequest_FileItem {
    const message = createBaseDmCompAccDataUploadRequest_FileItem();
    message.file_content = object.file_content ?? new Uint8Array(0);
    message.file_name = object.file_name ?? "";
    return message;
  },
};

function createBaseDmCompAccDataUploadConfirmRequest(): DmCompAccDataUploadConfirmRequest {
  return { ref_id_comp: "", ref_id_org: "", ref_id_user: "" };
}

export const DmCompAccDataUploadConfirmRequest: MessageFns<DmCompAccDataUploadConfirmRequest> = {
  encode(message: DmCompAccDataUploadConfirmRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(34).string(message.ref_id_org);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(42).string(message.ref_id_user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompAccDataUploadConfirmRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompAccDataUploadConfirmRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompAccDataUploadConfirmRequest {
    return {
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
    };
  },

  toJSON(message: DmCompAccDataUploadConfirmRequest): unknown {
    const obj: any = {};
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompAccDataUploadConfirmRequest>, I>>(
    base?: I,
  ): DmCompAccDataUploadConfirmRequest {
    return DmCompAccDataUploadConfirmRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompAccDataUploadConfirmRequest>, I>>(
    object: I,
  ): DmCompAccDataUploadConfirmRequest {
    const message = createBaseDmCompAccDataUploadConfirmRequest();
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    return message;
  },
};

function createBaseDmCompAcmConfirmRequest(): DmCompAcmConfirmRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "" };
}

export const DmCompAcmConfirmRequest: MessageFns<DmCompAcmConfirmRequest> = {
  encode(message: DmCompAcmConfirmRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompAcmConfirmRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompAcmConfirmRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompAcmConfirmRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: DmCompAcmConfirmRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompAcmConfirmRequest>, I>>(base?: I): DmCompAcmConfirmRequest {
    return DmCompAcmConfirmRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompAcmConfirmRequest>, I>>(object: I): DmCompAcmConfirmRequest {
    const message = createBaseDmCompAcmConfirmRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseDmCompAcmGetRequest(): DmCompAcmGetRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "" };
}

export const DmCompAcmGetRequest: MessageFns<DmCompAcmGetRequest> = {
  encode(message: DmCompAcmGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompAcmGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompAcmGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompAcmGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: DmCompAcmGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompAcmGetRequest>, I>>(base?: I): DmCompAcmGetRequest {
    return DmCompAcmGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompAcmGetRequest>, I>>(object: I): DmCompAcmGetRequest {
    const message = createBaseDmCompAcmGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseDmCompAcmGetDraftRequest(): DmCompAcmGetDraftRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "" };
}

export const DmCompAcmGetDraftRequest: MessageFns<DmCompAcmGetDraftRequest> = {
  encode(message: DmCompAcmGetDraftRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompAcmGetDraftRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompAcmGetDraftRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompAcmGetDraftRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: DmCompAcmGetDraftRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompAcmGetDraftRequest>, I>>(base?: I): DmCompAcmGetDraftRequest {
    return DmCompAcmGetDraftRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompAcmGetDraftRequest>, I>>(object: I): DmCompAcmGetDraftRequest {
    const message = createBaseDmCompAcmGetDraftRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseDmCompAcmPreviewRequest(): DmCompAcmPreviewRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "" };
}

export const DmCompAcmPreviewRequest: MessageFns<DmCompAcmPreviewRequest> = {
  encode(message: DmCompAcmPreviewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompAcmPreviewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompAcmPreviewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompAcmPreviewRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: DmCompAcmPreviewRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompAcmPreviewRequest>, I>>(base?: I): DmCompAcmPreviewRequest {
    return DmCompAcmPreviewRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompAcmPreviewRequest>, I>>(object: I): DmCompAcmPreviewRequest {
    const message = createBaseDmCompAcmPreviewRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseDmCompAcmRestoreRequest(): DmCompAcmRestoreRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "" };
}

export const DmCompAcmRestoreRequest: MessageFns<DmCompAcmRestoreRequest> = {
  encode(message: DmCompAcmRestoreRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompAcmRestoreRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompAcmRestoreRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompAcmRestoreRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: DmCompAcmRestoreRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompAcmRestoreRequest>, I>>(base?: I): DmCompAcmRestoreRequest {
    return DmCompAcmRestoreRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompAcmRestoreRequest>, I>>(object: I): DmCompAcmRestoreRequest {
    const message = createBaseDmCompAcmRestoreRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseDmCompAcmSaveDraftRequest(): DmCompAcmSaveDraftRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", comp_acc_mapping: undefined };
}

export const DmCompAcmSaveDraftRequest: MessageFns<DmCompAcmSaveDraftRequest> = {
  encode(message: DmCompAcmSaveDraftRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.comp_acc_mapping !== undefined) {
      StcsCompAccMapping.encode(message.comp_acc_mapping, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompAcmSaveDraftRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompAcmSaveDraftRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.comp_acc_mapping = StcsCompAccMapping.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompAcmSaveDraftRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      comp_acc_mapping: isSet(object.comp_acc_mapping)
        ? StcsCompAccMapping.fromJSON(object.comp_acc_mapping)
        : undefined,
    };
  },

  toJSON(message: DmCompAcmSaveDraftRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.comp_acc_mapping !== undefined) {
      obj.comp_acc_mapping = StcsCompAccMapping.toJSON(message.comp_acc_mapping);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompAcmSaveDraftRequest>, I>>(base?: I): DmCompAcmSaveDraftRequest {
    return DmCompAcmSaveDraftRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompAcmSaveDraftRequest>, I>>(object: I): DmCompAcmSaveDraftRequest {
    const message = createBaseDmCompAcmSaveDraftRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.comp_acc_mapping = (object.comp_acc_mapping !== undefined && object.comp_acc_mapping !== null)
      ? StcsCompAccMapping.fromPartial(object.comp_acc_mapping)
      : undefined;
    return message;
  },
};

function createBaseDmOrgFsdFlatGetRequest(): DmOrgFsdFlatGetRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const DmOrgFsdFlatGetRequest: MessageFns<DmOrgFsdFlatGetRequest> = {
  encode(message: DmOrgFsdFlatGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdFlatGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdFlatGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdFlatGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: DmOrgFsdFlatGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdFlatGetRequest>, I>>(base?: I): DmOrgFsdFlatGetRequest {
    return DmOrgFsdFlatGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdFlatGetRequest>, I>>(object: I): DmOrgFsdFlatGetRequest {
    const message = createBaseDmOrgFsdFlatGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseDmOrgFsdFlatGetDraftRequest(): DmOrgFsdFlatGetDraftRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const DmOrgFsdFlatGetDraftRequest: MessageFns<DmOrgFsdFlatGetDraftRequest> = {
  encode(message: DmOrgFsdFlatGetDraftRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdFlatGetDraftRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdFlatGetDraftRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdFlatGetDraftRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: DmOrgFsdFlatGetDraftRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdFlatGetDraftRequest>, I>>(base?: I): DmOrgFsdFlatGetDraftRequest {
    return DmOrgFsdFlatGetDraftRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdFlatGetDraftRequest>, I>>(object: I): DmOrgFsdFlatGetDraftRequest {
    const message = createBaseDmOrgFsdFlatGetDraftRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseDmOrgFsdFlatRestoreRequest(): DmOrgFsdFlatRestoreRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const DmOrgFsdFlatRestoreRequest: MessageFns<DmOrgFsdFlatRestoreRequest> = {
  encode(message: DmOrgFsdFlatRestoreRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdFlatRestoreRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdFlatRestoreRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdFlatRestoreRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: DmOrgFsdFlatRestoreRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdFlatRestoreRequest>, I>>(base?: I): DmOrgFsdFlatRestoreRequest {
    return DmOrgFsdFlatRestoreRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdFlatRestoreRequest>, I>>(object: I): DmOrgFsdFlatRestoreRequest {
    const message = createBaseDmOrgFsdFlatRestoreRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseDmOrgFsdFlatPreviewRequest(): DmOrgFsdFlatPreviewRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const DmOrgFsdFlatPreviewRequest: MessageFns<DmOrgFsdFlatPreviewRequest> = {
  encode(message: DmOrgFsdFlatPreviewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdFlatPreviewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdFlatPreviewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdFlatPreviewRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: DmOrgFsdFlatPreviewRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdFlatPreviewRequest>, I>>(base?: I): DmOrgFsdFlatPreviewRequest {
    return DmOrgFsdFlatPreviewRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdFlatPreviewRequest>, I>>(object: I): DmOrgFsdFlatPreviewRequest {
    const message = createBaseDmOrgFsdFlatPreviewRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseDmOrgFsdFlatSaveDraftRequest(): DmOrgFsdFlatSaveDraftRequest {
  return { ref_id_user: "", ref_id_org: "", obj_org_fsd_flat: undefined };
}

export const DmOrgFsdFlatSaveDraftRequest: MessageFns<DmOrgFsdFlatSaveDraftRequest> = {
  encode(message: DmOrgFsdFlatSaveDraftRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.obj_org_fsd_flat !== undefined) {
      StcsOrgFsdFlat.encode(message.obj_org_fsd_flat, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdFlatSaveDraftRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdFlatSaveDraftRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obj_org_fsd_flat = StcsOrgFsdFlat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdFlatSaveDraftRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      obj_org_fsd_flat: isSet(object.obj_org_fsd_flat) ? StcsOrgFsdFlat.fromJSON(object.obj_org_fsd_flat) : undefined,
    };
  },

  toJSON(message: DmOrgFsdFlatSaveDraftRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.obj_org_fsd_flat !== undefined) {
      obj.obj_org_fsd_flat = StcsOrgFsdFlat.toJSON(message.obj_org_fsd_flat);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdFlatSaveDraftRequest>, I>>(base?: I): DmOrgFsdFlatSaveDraftRequest {
    return DmOrgFsdFlatSaveDraftRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdFlatSaveDraftRequest>, I>>(object: I): DmOrgFsdFlatSaveDraftRequest {
    const message = createBaseDmOrgFsdFlatSaveDraftRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.obj_org_fsd_flat = (object.obj_org_fsd_flat !== undefined && object.obj_org_fsd_flat !== null)
      ? StcsOrgFsdFlat.fromPartial(object.obj_org_fsd_flat)
      : undefined;
    return message;
  },
};

function createBaseDmOrgFsdFlatConfirmRequest(): DmOrgFsdFlatConfirmRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const DmOrgFsdFlatConfirmRequest: MessageFns<DmOrgFsdFlatConfirmRequest> = {
  encode(message: DmOrgFsdFlatConfirmRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdFlatConfirmRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdFlatConfirmRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdFlatConfirmRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: DmOrgFsdFlatConfirmRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdFlatConfirmRequest>, I>>(base?: I): DmOrgFsdFlatConfirmRequest {
    return DmOrgFsdFlatConfirmRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdFlatConfirmRequest>, I>>(object: I): DmOrgFsdFlatConfirmRequest {
    const message = createBaseDmOrgFsdFlatConfirmRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseDmOrgFsdTemplateListRequest(): DmOrgFsdTemplateListRequest {
  return { ref_id_user: "" };
}

export const DmOrgFsdTemplateListRequest: MessageFns<DmOrgFsdTemplateListRequest> = {
  encode(message: DmOrgFsdTemplateListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdTemplateListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdTemplateListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdTemplateListRequest {
    return { ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "" };
  },

  toJSON(message: DmOrgFsdTemplateListRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdTemplateListRequest>, I>>(base?: I): DmOrgFsdTemplateListRequest {
    return DmOrgFsdTemplateListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdTemplateListRequest>, I>>(object: I): DmOrgFsdTemplateListRequest {
    const message = createBaseDmOrgFsdTemplateListRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    return message;
  },
};

function createBaseDmOrgFsdTemplateApplyRequest(): DmOrgFsdTemplateApplyRequest {
  return { ref_id_user: "", ref_id_org: "", fpna_industry: 0 };
}

export const DmOrgFsdTemplateApplyRequest: MessageFns<DmOrgFsdTemplateApplyRequest> = {
  encode(message: DmOrgFsdTemplateApplyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.fpna_industry !== 0) {
      writer.uint32(24).uint32(message.fpna_industry);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmOrgFsdTemplateApplyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmOrgFsdTemplateApplyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fpna_industry = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmOrgFsdTemplateApplyRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      fpna_industry: isSet(object.fpna_industry) ? globalThis.Number(object.fpna_industry) : 0,
    };
  },

  toJSON(message: DmOrgFsdTemplateApplyRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.fpna_industry !== 0) {
      obj.fpna_industry = Math.round(message.fpna_industry);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmOrgFsdTemplateApplyRequest>, I>>(base?: I): DmOrgFsdTemplateApplyRequest {
    return DmOrgFsdTemplateApplyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmOrgFsdTemplateApplyRequest>, I>>(object: I): DmOrgFsdTemplateApplyRequest {
    const message = createBaseDmOrgFsdTemplateApplyRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.fpna_industry = object.fpna_industry ?? 0;
    return message;
  },
};

function createBaseDmCompDataOverViewRequest(): DmCompDataOverViewRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const DmCompDataOverViewRequest: MessageFns<DmCompDataOverViewRequest> = {
  encode(message: DmCompDataOverViewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompDataOverViewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompDataOverViewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompDataOverViewRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: DmCompDataOverViewRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompDataOverViewRequest>, I>>(base?: I): DmCompDataOverViewRequest {
    return DmCompDataOverViewRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompDataOverViewRequest>, I>>(object: I): DmCompDataOverViewRequest {
    const message = createBaseDmCompDataOverViewRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseDmCompDeleteActualsRequest(): DmCompDeleteActualsRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", months_to_delete: 0, delete_actuals_data: false };
}

export const DmCompDeleteActualsRequest: MessageFns<DmCompDeleteActualsRequest> = {
  encode(message: DmCompDeleteActualsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.months_to_delete !== 0) {
      writer.uint32(32).uint32(message.months_to_delete);
    }
    if (message.delete_actuals_data !== false) {
      writer.uint32(40).bool(message.delete_actuals_data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DmCompDeleteActualsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDmCompDeleteActualsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.months_to_delete = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.delete_actuals_data = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DmCompDeleteActualsRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      months_to_delete: isSet(object.months_to_delete) ? globalThis.Number(object.months_to_delete) : 0,
      delete_actuals_data: isSet(object.delete_actuals_data) ? globalThis.Boolean(object.delete_actuals_data) : false,
    };
  },

  toJSON(message: DmCompDeleteActualsRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.months_to_delete !== 0) {
      obj.months_to_delete = Math.round(message.months_to_delete);
    }
    if (message.delete_actuals_data !== false) {
      obj.delete_actuals_data = message.delete_actuals_data;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DmCompDeleteActualsRequest>, I>>(base?: I): DmCompDeleteActualsRequest {
    return DmCompDeleteActualsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DmCompDeleteActualsRequest>, I>>(object: I): DmCompDeleteActualsRequest {
    const message = createBaseDmCompDeleteActualsRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.months_to_delete = object.months_to_delete ?? 0;
    message.delete_actuals_data = object.delete_actuals_data ?? false;
    return message;
  },
};

function createBaseCreateCompAccMappingRequest(): CreateCompAccMappingRequest {
  return {
    ref_id_comp_plan_cfg_template: undefined,
    ref_id_comp: "",
    ref_id_org: "",
    ref_id_user: "",
    display_name: "",
    fpna_begin_date_string: "",
    fpna_end_date_string: "",
  };
}

export const CreateCompAccMappingRequest: MessageFns<CreateCompAccMappingRequest> = {
  encode(message: CreateCompAccMappingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_comp_plan_cfg_template !== undefined) {
      writer.uint32(10).string(message.ref_id_comp_plan_cfg_template);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(42).string(message.ref_id_comp);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(50).string(message.ref_id_org);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(58).string(message.ref_id_user);
    }
    if (message.display_name !== "") {
      writer.uint32(18).string(message.display_name);
    }
    if (message.fpna_begin_date_string !== "") {
      writer.uint32(26).string(message.fpna_begin_date_string);
    }
    if (message.fpna_end_date_string !== "") {
      writer.uint32(34).string(message.fpna_end_date_string);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCompAccMappingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCompAccMappingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_comp_plan_cfg_template = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fpna_begin_date_string = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fpna_end_date_string = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCompAccMappingRequest {
    return {
      ref_id_comp_plan_cfg_template: isSet(object.ref_id_comp_plan_cfg_template)
        ? globalThis.String(object.ref_id_comp_plan_cfg_template)
        : undefined,
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      fpna_begin_date_string: isSet(object.fpna_begin_date_string)
        ? globalThis.String(object.fpna_begin_date_string)
        : "",
      fpna_end_date_string: isSet(object.fpna_end_date_string) ? globalThis.String(object.fpna_end_date_string) : "",
    };
  },

  toJSON(message: CreateCompAccMappingRequest): unknown {
    const obj: any = {};
    if (message.ref_id_comp_plan_cfg_template !== undefined) {
      obj.ref_id_comp_plan_cfg_template = message.ref_id_comp_plan_cfg_template;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.fpna_begin_date_string !== "") {
      obj.fpna_begin_date_string = message.fpna_begin_date_string;
    }
    if (message.fpna_end_date_string !== "") {
      obj.fpna_end_date_string = message.fpna_end_date_string;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCompAccMappingRequest>, I>>(base?: I): CreateCompAccMappingRequest {
    return CreateCompAccMappingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCompAccMappingRequest>, I>>(object: I): CreateCompAccMappingRequest {
    const message = createBaseCreateCompAccMappingRequest();
    message.ref_id_comp_plan_cfg_template = object.ref_id_comp_plan_cfg_template ?? undefined;
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.display_name = object.display_name ?? "";
    message.fpna_begin_date_string = object.fpna_begin_date_string ?? "";
    message.fpna_end_date_string = object.fpna_end_date_string ?? "";
    return message;
  },
};

function createBaseDeleteCompAccMappingRequest(): DeleteCompAccMappingRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const DeleteCompAccMappingRequest: MessageFns<DeleteCompAccMappingRequest> = {
  encode(message: DeleteCompAccMappingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCompAccMappingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCompAccMappingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCompAccMappingRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: DeleteCompAccMappingRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCompAccMappingRequest>, I>>(base?: I): DeleteCompAccMappingRequest {
    return DeleteCompAccMappingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCompAccMappingRequest>, I>>(object: I): DeleteCompAccMappingRequest {
    const message = createBaseDeleteCompAccMappingRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseGetCompAccMappingListRequest(): GetCompAccMappingListRequest {
  return { ref_id_comp: "", ref_id_org: "", ref_id_user: "" };
}

export const GetCompAccMappingListRequest: MessageFns<GetCompAccMappingListRequest> = {
  encode(message: GetCompAccMappingListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_comp !== "") {
      writer.uint32(10).string(message.ref_id_comp);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(26).string(message.ref_id_user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCompAccMappingListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCompAccMappingListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCompAccMappingListRequest {
    return {
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
    };
  },

  toJSON(message: GetCompAccMappingListRequest): unknown {
    const obj: any = {};
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCompAccMappingListRequest>, I>>(base?: I): GetCompAccMappingListRequest {
    return GetCompAccMappingListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCompAccMappingListRequest>, I>>(object: I): GetCompAccMappingListRequest {
    const message = createBaseGetCompAccMappingListRequest();
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    return message;
  },
};

export interface StcsWappSvcDataManagement {
  dm_comp_acc_data_upload(
    request: DeepPartial<DmCompAccDataUploadRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  dm_comp_acc_data_upload_confirm(
    request: DeepPartial<DmCompAccDataUploadConfirmRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  dm_comp_acm_confirm(
    request: DeepPartial<DmCompAcmConfirmRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_comp_acm_get(
    request: DeepPartial<DmCompAcmGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_comp_acm_get_draft(
    request: DeepPartial<DmCompAcmGetDraftRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_comp_acm_preview(
    request: DeepPartial<DmCompAcmPreviewRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  dm_comp_acm_restore(
    request: DeepPartial<DmCompAcmRestoreRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_comp_acm_save_draft(
    request: DeepPartial<DmCompAcmSaveDraftRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_comp_data_overview(
    request: DeepPartial<DmCompDataOverViewRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  dm_comp_delete_actuals(
    request: DeepPartial<DmCompDeleteActualsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_org_fsd_flat_confirm(
    request: DeepPartial<DmOrgFsdFlatConfirmRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_org_fsd_flat_get(
    request: DeepPartial<DmOrgFsdFlatGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_org_fsd_flat_get_draft(
    request: DeepPartial<DmOrgFsdFlatGetDraftRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_org_fsd_flat_preview(
    request: DeepPartial<DmOrgFsdFlatPreviewRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  dm_org_fsd_flat_restore(
    request: DeepPartial<DmOrgFsdFlatRestoreRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_org_fsd_flat_save_draft(
    request: DeepPartial<DmOrgFsdFlatSaveDraftRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_org_fsd_template_apply(
    request: DeepPartial<DmOrgFsdTemplateApplyRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  dm_org_fsd_template_list(
    request: DeepPartial<DmOrgFsdTemplateListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
}

export class StcsWappSvcDataManagementClientImpl implements StcsWappSvcDataManagement {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.dm_comp_acc_data_upload = this.dm_comp_acc_data_upload.bind(this);
    this.dm_comp_acc_data_upload_confirm = this.dm_comp_acc_data_upload_confirm.bind(this);
    this.dm_comp_acm_confirm = this.dm_comp_acm_confirm.bind(this);
    this.dm_comp_acm_get = this.dm_comp_acm_get.bind(this);
    this.dm_comp_acm_get_draft = this.dm_comp_acm_get_draft.bind(this);
    this.dm_comp_acm_preview = this.dm_comp_acm_preview.bind(this);
    this.dm_comp_acm_restore = this.dm_comp_acm_restore.bind(this);
    this.dm_comp_acm_save_draft = this.dm_comp_acm_save_draft.bind(this);
    this.dm_comp_data_overview = this.dm_comp_data_overview.bind(this);
    this.dm_comp_delete_actuals = this.dm_comp_delete_actuals.bind(this);
    this.dm_org_fsd_flat_confirm = this.dm_org_fsd_flat_confirm.bind(this);
    this.dm_org_fsd_flat_get = this.dm_org_fsd_flat_get.bind(this);
    this.dm_org_fsd_flat_get_draft = this.dm_org_fsd_flat_get_draft.bind(this);
    this.dm_org_fsd_flat_preview = this.dm_org_fsd_flat_preview.bind(this);
    this.dm_org_fsd_flat_restore = this.dm_org_fsd_flat_restore.bind(this);
    this.dm_org_fsd_flat_save_draft = this.dm_org_fsd_flat_save_draft.bind(this);
    this.dm_org_fsd_template_apply = this.dm_org_fsd_template_apply.bind(this);
    this.dm_org_fsd_template_list = this.dm_org_fsd_template_list.bind(this);
  }

  dm_comp_acc_data_upload(
    request: DeepPartial<DmCompAccDataUploadRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_acc_data_uploadDesc,
      DmCompAccDataUploadRequest.fromPartial(request),
      metadata,
    );
  }

  dm_comp_acc_data_upload_confirm(
    request: DeepPartial<DmCompAccDataUploadConfirmRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_acc_data_upload_confirmDesc,
      DmCompAccDataUploadConfirmRequest.fromPartial(request),
      metadata,
    );
  }

  dm_comp_acm_confirm(
    request: DeepPartial<DmCompAcmConfirmRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_acm_confirmDesc,
      DmCompAcmConfirmRequest.fromPartial(request),
      metadata,
    );
  }

  dm_comp_acm_get(
    request: DeepPartial<DmCompAcmGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_acm_getDesc,
      DmCompAcmGetRequest.fromPartial(request),
      metadata,
    );
  }

  dm_comp_acm_get_draft(
    request: DeepPartial<DmCompAcmGetDraftRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_acm_get_draftDesc,
      DmCompAcmGetDraftRequest.fromPartial(request),
      metadata,
    );
  }

  dm_comp_acm_preview(
    request: DeepPartial<DmCompAcmPreviewRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_acm_previewDesc,
      DmCompAcmPreviewRequest.fromPartial(request),
      metadata,
    );
  }

  dm_comp_acm_restore(
    request: DeepPartial<DmCompAcmRestoreRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_acm_restoreDesc,
      DmCompAcmRestoreRequest.fromPartial(request),
      metadata,
    );
  }

  dm_comp_acm_save_draft(
    request: DeepPartial<DmCompAcmSaveDraftRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_acm_save_draftDesc,
      DmCompAcmSaveDraftRequest.fromPartial(request),
      metadata,
    );
  }

  dm_comp_data_overview(
    request: DeepPartial<DmCompDataOverViewRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_data_overviewDesc,
      DmCompDataOverViewRequest.fromPartial(request),
      metadata,
    );
  }

  dm_comp_delete_actuals(
    request: DeepPartial<DmCompDeleteActualsRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_comp_delete_actualsDesc,
      DmCompDeleteActualsRequest.fromPartial(request),
      metadata,
    );
  }

  dm_org_fsd_flat_confirm(
    request: DeepPartial<DmOrgFsdFlatConfirmRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_org_fsd_flat_confirmDesc,
      DmOrgFsdFlatConfirmRequest.fromPartial(request),
      metadata,
    );
  }

  dm_org_fsd_flat_get(
    request: DeepPartial<DmOrgFsdFlatGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_org_fsd_flat_getDesc,
      DmOrgFsdFlatGetRequest.fromPartial(request),
      metadata,
    );
  }

  dm_org_fsd_flat_get_draft(
    request: DeepPartial<DmOrgFsdFlatGetDraftRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_org_fsd_flat_get_draftDesc,
      DmOrgFsdFlatGetDraftRequest.fromPartial(request),
      metadata,
    );
  }

  dm_org_fsd_flat_preview(
    request: DeepPartial<DmOrgFsdFlatPreviewRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_org_fsd_flat_previewDesc,
      DmOrgFsdFlatPreviewRequest.fromPartial(request),
      metadata,
    );
  }

  dm_org_fsd_flat_restore(
    request: DeepPartial<DmOrgFsdFlatRestoreRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_org_fsd_flat_restoreDesc,
      DmOrgFsdFlatRestoreRequest.fromPartial(request),
      metadata,
    );
  }

  dm_org_fsd_flat_save_draft(
    request: DeepPartial<DmOrgFsdFlatSaveDraftRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_org_fsd_flat_save_draftDesc,
      DmOrgFsdFlatSaveDraftRequest.fromPartial(request),
      metadata,
    );
  }

  dm_org_fsd_template_apply(
    request: DeepPartial<DmOrgFsdTemplateApplyRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_org_fsd_template_applyDesc,
      DmOrgFsdTemplateApplyRequest.fromPartial(request),
      metadata,
    );
  }

  dm_org_fsd_template_list(
    request: DeepPartial<DmOrgFsdTemplateListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcDataManagementdm_org_fsd_template_listDesc,
      DmOrgFsdTemplateListRequest.fromPartial(request),
      metadata,
    );
  }
}

export const StcsWappSvcDataManagementDesc = { serviceName: "stcs_cmw.StcsWappSvcDataManagement" };

export const StcsWappSvcDataManagementdm_comp_acc_data_uploadDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_acc_data_upload",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompAccDataUploadRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_comp_acc_data_upload_confirmDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_acc_data_upload_confirm",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompAccDataUploadConfirmRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_comp_acm_confirmDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_acm_confirm",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompAcmConfirmRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_comp_acm_getDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_acm_get",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompAcmGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_comp_acm_get_draftDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_acm_get_draft",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompAcmGetDraftRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_comp_acm_previewDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_acm_preview",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompAcmPreviewRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_comp_acm_restoreDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_acm_restore",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompAcmRestoreRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_comp_acm_save_draftDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_acm_save_draft",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompAcmSaveDraftRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_comp_data_overviewDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_data_overview",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompDataOverViewRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_comp_delete_actualsDesc: UnaryMethodDefinitionish = {
  methodName: "dm_comp_delete_actuals",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmCompDeleteActualsRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_org_fsd_flat_confirmDesc: UnaryMethodDefinitionish = {
  methodName: "dm_org_fsd_flat_confirm",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmOrgFsdFlatConfirmRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_org_fsd_flat_getDesc: UnaryMethodDefinitionish = {
  methodName: "dm_org_fsd_flat_get",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmOrgFsdFlatGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_org_fsd_flat_get_draftDesc: UnaryMethodDefinitionish = {
  methodName: "dm_org_fsd_flat_get_draft",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmOrgFsdFlatGetDraftRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_org_fsd_flat_previewDesc: UnaryMethodDefinitionish = {
  methodName: "dm_org_fsd_flat_preview",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmOrgFsdFlatPreviewRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_org_fsd_flat_restoreDesc: UnaryMethodDefinitionish = {
  methodName: "dm_org_fsd_flat_restore",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmOrgFsdFlatRestoreRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_org_fsd_flat_save_draftDesc: UnaryMethodDefinitionish = {
  methodName: "dm_org_fsd_flat_save_draft",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmOrgFsdFlatSaveDraftRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_org_fsd_template_applyDesc: UnaryMethodDefinitionish = {
  methodName: "dm_org_fsd_template_apply",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmOrgFsdTemplateApplyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcDataManagementdm_org_fsd_template_listDesc: UnaryMethodDefinitionish = {
  methodName: "dm_org_fsd_template_list",
  service: StcsWappSvcDataManagementDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DmOrgFsdTemplateListRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
